import React from 'react';
import Paper from '@mui/material/Paper';
// import Box from '@mui/material/Box';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Parallax, Pagination, Navigation } from 'swiper/modules';

export const SwapInstruction = () => {
  return (
    <div>
      <Paper
        elevation={5}
        sx={{
          px: 2,
          py: 2,
          borderRadius: 3,
          minHeight: 432.5
        }}
      >
        <Swiper
          speed={600}
          parallax={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Parallax, Pagination, Navigation]}
          className="fairblock-swiper"
        >
          <div
            slot="container-start"
            className="parallax-bg"
            // style={{
            //   'backgroundImage':
            //     'url(https://swiperjs.com/demos/images/nature-1.jpg)',
            // }}
            data-swiper-parallax="-23%"
          ></div>
          <SwiperSlide>
            <div className="title" data-swiper-parallax="-300">
              What is it
            </div>
            <div className="text" data-swiper-parallax="-100">
              <p>
                A UniswapV2 type DEX deployed on an Arbitrum orbit testnet that
                allows for sending encrypted limit orders.
              </p>
            </div>
            <div className="text" data-swiper-parallax="-100">
              <p>
                Users encrypt their orders to a specific price in a particular
                pool. Once the pool price reaches that amount, the order is
                decrypted and then executed.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="title" data-swiper-parallax="-300">
              How it works
            </div>
            <div className="text" data-swiper-parallax="-100">
              <p>
                Users specify limit order condition (i.e. execute my transaction
                when ETH/USDC price is 1500).
              </p>
              <p>
                Once pool reaches the price threshold, a decryption key request
                is made to fairyring.
              </p>
              <p>
                Validators on fairyring generate decryption key for the price
                threshold.
              </p>
              <p>
                The decryption key is relayed to Arbitrum testnet and the swap
                is executed.
              </p>
            </div>
          </SwiperSlide>
        </Swiper>
      </Paper>
    </div>
  );
};
